import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { initLocales } from '../locales';

// Detected at module load (before React renders) — true when SSR injected the hiding style
const ssrPage = typeof document !== 'undefined' && !!document.getElementById('ssr-hiding');

function TranslationsConnection({ children }) {
  const [localesReady, setLocalesReady] = useState(false);

  useEffect(() => {
    initLocales(() => setLocalesReady(true));
  }, []);

  useEffect(() => {
    if (!localesReady) return;
    const el = document.getElementById('ssr-hiding');
    if (el) el.parentNode.removeChild(el);
  }, [localesReady]);

  // Server: always render children (needed for SSR output)
  // Client SSR page: render children immediately so hydration matches server output;
  //   opacity:0 (ssr-hiding) keeps content invisible until locales are ready
  // Client non-SSR page: wait for locales before rendering (avoids flash of untranslated text)
  if (typeof window === 'undefined') return children;
  return (ssrPage || localesReady) ? children : false;
}

TranslationsConnection.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export default TranslationsConnection;
